import React, { Dispatch, FC, SetStateAction, useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { AsideMenu } from './AsideMenu'
import { useSelector } from 'react-redux'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'
import { isEmpty, iteratee } from 'lodash'
import { imageBaseUrl } from 'src/cms/helpers/constants'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import { Drawer } from 'antd'
import { ActiveMenuContex } from '../../MasterLayout'

const AsideDefault: FC = () => {
  const location = useLocation()
  const { config, classes } = useLayout()
  const { aside } = config
  const [logo, setLogo] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const activeMenu: any = useContext(ActiveMenuContex)
  useEffect(() => {
    onClose()
  }, [location])
  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(item?.value)
          }
        })
    }
  }, [settingTypeData])
  const onClose = () => {
    activeMenu.setOpen(false);
  };
  return (
    <Drawer title="Main menu" onClose={onClose} open={activeMenu.open}
      placement="left"
    >
      <div>
        {/* begin::Aside menu */}
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
        {/* end::Aside menu */}
      </div>
    </Drawer>
  )
}

export { AsideDefault }
